const apiBaseUrl = process.env.NEXT_PUBLIC_API_BASE_URL ?? 'http://127.0.0.1:8787';

export type ScheduleQuarter = 'first_half' | 'second_half';
export type ScheduleInputPeriod = 'first_half' | 'second_half';

export type ScheduleRow = {
  id: number;
  item: string;
  date: string;
  note: string;
};

export type AlertSetting = {
  id: number;
  enabled: boolean;
  itemId: number;
  daysBefore: number;
  sendTime: string;
  message: string;
};

export type ScheduleSettings = {
  termNo?: number;
  terms?: { termNo: number; startDate: string; endDate: string }[];
  evaluationInputPeriods: Record<
    ScheduleInputPeriod,
    {
      fromDate: string;
      toDate: string;
    }
  >;
  scheduleData: Record<ScheduleQuarter, ScheduleRow[]>;
  alertSettings: Record<ScheduleQuarter, AlertSetting[]>;
};

async function throwIfNotOk(response: Response) {
  if (response.ok) return;
  const payload = await response.json().catch(() => ({}));
  const issueMessage =
    Array.isArray((payload as { issues?: Array<{ message?: string }> }).issues) &&
    (payload as { issues?: Array<{ message?: string }> }).issues![0]?.message
      ? `: ${(payload as { issues: Array<{ message?: string }> }).issues[0].message}`
      : '';
  const message = typeof payload.message === 'string'
    ? `${payload.message}${issueMessage}`
    : 'API request failed';
  throw new Error(message);
}

export async function fetchScheduleSettings(termNo?: number) {
  const search = typeof termNo === 'number' ? `?termNo=${termNo}` : '';
  const response = await fetch(`${apiBaseUrl}/api/admin/schedule-settings${search}`);
  await throwIfNotOk(response);
  return (await response.json()) as ScheduleSettings;
}

export async function saveScheduleSettings(input: ScheduleSettings, termNo?: number) {
  const search = typeof termNo === 'number' ? `?termNo=${termNo}` : '';
  const response = await fetch(`${apiBaseUrl}/api/admin/schedule-settings${search}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(input),
  });
  await throwIfNotOk(response);
  const payload = (await response.json()) as { result: { updated: boolean } };
  return payload.result;
}

export async function sendScheduleLineNow(input: {
  termNo?: number;
  quarter: ScheduleQuarter;
  alertId?: number;
}) {
  const response = await fetch(`${apiBaseUrl}/api/admin/schedule-settings/send-line-now`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(input),
  });
  await throwIfNotOk(response);
  const payload = (await response.json()) as { result: { successCount: number } };
  return payload.result;
}
